import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e785e74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex items-center justify-center",
  style: { height: '100vh', width: '100vw' }
}
const _hoisted_2 = {
  class: "flex flex-col rounded-12 border-2 border-charcoal relative rise-animation",
  style: { width: '360px' }
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-center mx-34 py-20" }, "⛲", -1))
const _hoisted_4 = { class: "text-note flex items-center justify-center icon-lg" }
const _hoisted_5 = { class: "note flex-1 ellipsis" }
const _hoisted_6 = { class: "flex mx-34 my-20 gap-12" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" logout ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" new ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AuthGuard = _resolveComponent("AuthGuard")!

  return (_openBlock(), _createBlock(_component_AuthGuard, {
    workspace: false,
    onValid: _ctx.handleValid
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspaces, (workspace) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: '/-/' + workspace.id,
              class: "clickable flex gap-12 items-center workspace-item text-charcoal p-cell",
              style: { 'text-decoration': 'none' },
              key: workspace
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(workspace.icon), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(workspace.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/login",
              onClick: _ctx.logout,
              class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_router_link, {
              to: "/new",
              class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onValid"]))
}